import { NgModule } from "@angular/core";
import { PipesModule } from "../pipes/pipes.module";
import { SharedModule } from "../shared";
import { CertificateCrudModule } from "./certificate";
import { KeyFormComponent } from "./key-form.component";
import { KeyRoutingModule } from "./key-routing.module";
import { PrivateKeyCrudModule } from "./private-key";

const DIRECTIVES = [KeyFormComponent];

@NgModule({
	imports: [
		SharedModule,
		CertificateCrudModule,
		PrivateKeyCrudModule,
		PipesModule,
		KeyRoutingModule,
	],
	declarations: [...DIRECTIVES],
	exports: [...DIRECTIVES],
})
export class KeyCrudModule {}
